import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import BackButton from '../assets/icons/BackButton';
import Heading from '../ui/Heading';
import AllClaimedCards from '../features/gallery/claimed/AllClaimedCards';
import AllUnclaimedCards from '../features/gallery/unclaimed/AllUnclaimedCards';
import AllMintedCards from '../features/gallery/minted/AllMintedCards';
import { useContext, useEffect, useState, useCallback } from 'react';
import { getAllCertificates } from '../apis/impactCertificates/impactCertificates';
import { useLoadingState } from '../hooks/useLoader';
import { ProfileContext } from '../contexts/ProfileContext';
import AllMintRequested from '../features/gallery/mintRequested/AllMintRequested';
import Achievment from '../features/greenpill/Achievment';
import emptyStateImage from '../assets/emptystate.png';
import { AuthContext } from '../contexts/AuthContext';
import MetamaskConnection from '../features/walletConnection/MetamaskConnection';
import PhantomConnection from '../features/walletConnection/PhantomConnection';
import CloseIcon from '../assets/icons/CloseIcon';
import bountyRequestDone from "../assets/bountyRequestDone.gif"

function Gallery() {
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    const [viewGallery, setViewGallery] = useState('all');
    const { state, dispatch } = useContext(ProfileContext);
    const [sortBy, setSortBy] = useState('latest');
    const [showTooltip, setShowTooltip] = useState(null);
    const [askToConnectWallet, setAskToConnectWallet] = useState('');
    const [showMintingModal, setShowMintingModal] = useState(false);
    const [modalDismissed, setModalDismissed] = useState(false);
    const { state: authState } = useContext(AuthContext);
    const { user } = authState;
    const userProfile = user[0];
    const sParam = searchParams.get('s');

    // fetch latest certificates
    const refreshCertificates = useCallback(async () => {
        try {
            const fresh = await getAllCertificates();
            console.log(fresh, 'fresh from gallery');
            dispatch?.({ type: 'ic/setImpactcertificates', payload: fresh });
        } catch (err) {
            console.error('Could not refresh impact certificates', err);
        }
    }, [dispatch]);

    // refresh certificates when gallery mounts
    useEffect(() => {
        refreshCertificates();
    }, [refreshCertificates]);

    // Check for 's' query parameter on component mount
    useEffect(() => {
        
        if (sParam && !modalDismissed) {
            setShowMintingModal(true);
        }
    }, [searchParams, modalDismissed]);

    // Handle modal close and update URL
    const handleCloseMintingModal = () => {
        setShowMintingModal(false);
        setModalDismissed(true);
        // Replace current URL entry to remove s=true from history
        // This keeps user on Gallery but prevents back button from showing modal again
        const newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.delete('s');
        const newUrl = `${location.pathname}${newSearchParams.toString() ? '?' + newSearchParams.toString() : ''}`;
        window.history.replaceState(null, '', newUrl);
    };

    const unclaimedIcs = state.filter((ic) => ic.status === 'UNCLAIMED');
    const claimedIcs = state.filter((ic) => ic.status === 'CLAIMED');
    const mintedIcs = state.filter((ic) => ic.status === 'MINTED');
    const mintRequestedIcs = state.filter((ic) => ic.status === 'MINT_REQUESTED' || ic.status === 'MINTING');

        

    const handleSetViewGallery = (gallery) => {
        setViewGallery(gallery);
        refreshCertificates();
    };

    const EmptyState = () => (
        <div className="flex flex-col items-center justify-center mt-10">
            <img src={emptyStateImage} alt="Empty state" className="w-64 mb-4" />
            <p className="text-lg font-medium text-gray-700">Spread your mission! Take the first step ;)</p>
        </div>
    );

    // Minting Progress Modal Component
    const MintingProgressModal = () => (
        <div 
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]"
            onClick={handleCloseMintingModal}
        >
            <div 
                className="bg-grayBgNormal rounded-lg p-8  w-[45.375rem] mx-4 shadow-xl relative"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="absolute top-4 right-4 cursor-pointer" onClick={handleCloseMintingModal}>
                    <CloseIcon />
                </div>
                <div className="pb-4 border-b border-borderUnderline">
                                
                    <h3 className="text-2xl pr-6 break-words font-medium text-textPrimary">Project Impact Certificate created!</h3>
                    <p className='text-textSecondary'>Project Impact Certificate for ‘{sParam}’ has been created. Minting is in progress.</p>
                                
                </div>
                <div className="flex items-center   justify-center relative">
                 <div className="">
                {/* <p className="text-3xl font-semibold text-textPrimary">Bounty is being sent for treasury approval</p> */}
               
                <div className="flex items-center justify-center">
                    <img className="w-72 h-48 object-contain" src={bountyRequestDone} alt="" />
                </div>
                <p className="text-base  text-center   text-textPrimary absolute left-[50%] w-full translate-x-[-50%] bottom-5">
                 Please wait for 2-3 minutes before refreshing Hall of Impact
                </p>
            </div>
        </div>
            </div>
        </div>
    );
    console.log(setAskToConnectWallet, 'setAskToConnectWallet in Gallery');

    const renderContent = () => {
        if (viewGallery === 'all') {
            return (
                <>
                    {unclaimedIcs.length > 0 ? (
                        <AllUnclaimedCards
                            askToConnectWallet={askToConnectWallet}
                            setAskToConnectWallet={setAskToConnectWallet}
                        />
                    ) : null}
                    {claimedIcs.length > 0 ? (
                        <AllClaimedCards
                            askToConnectWallet={askToConnectWallet}
                            setAskToConnectWallet={setAskToConnectWallet}
                        />
                    ) : null}
                    {mintedIcs.length > 0 ? <AllMintedCards /> : null}
                    {mintRequestedIcs.length > 0 ? <AllMintRequested /> : null}
                </>
            );
        } else if (viewGallery === 'unclaimed') {
            return unclaimedIcs.length > 0 ? <AllUnclaimedCards /> : null;
        } else if (viewGallery === 'claimed') {
            return claimedIcs.length > 0 ? <AllClaimedCards /> : null;
        } else if (viewGallery === 'minted') {
            return mintedIcs.length > 0 ? <AllMintedCards /> : null;
        } else if (viewGallery === 'mintrequested' || viewGallery === 'minting' ) {
            return mintRequestedIcs.length > 0 ? <AllMintRequested /> : null;
        }

        return null;
    };
console.log(mintedIcs,"see this is the minted ic")
    return (
        <div className='pt-9 px-9'>
        <div className="px-5 pb-9">
            <div className="flex items-center">
                <BackButton onClick={() => navigate(-1)} />
                <Heading type={'pageHeading'} className={'text-textPrimary ml-3'}>
                    Hall of Impact
                </Heading>
            </div>
            <p className="text-lg text-secondaryText mt-5">
                Your personal gallery of impact on <span className="font-semibold">Humanity</span> and planet{' '}
                <span className="font-semibold"> Earth</span>.{' '}
            </p>
            <div className="flex items-center gap-9 my-8 ">
                {/* <div className="flex">
                    <p className="font-semibold">Sort By : </p> &nbsp;
                    <p
                        className="cursor-pointer "
                        onClick={() => {
                            setSortBy('latest');
                        }}
                    >
                        <span className={` ${sortBy === 'latest' ? 'text-textBrandBlue' : ''} `}>Latest</span>&nbsp;
                    </p>{' '}
                    <span>| &nbsp;</span>
                    <p
                        className="cursor-pointer"
                        onClick={() => {
                            setSortBy('oldest');
                        }}
                    >
                        <span className={` ${sortBy === 'oldest' ? 'text-textBrandBlue' : ''} `}>Oldest</span>
                        &nbsp;
                    </p>
                </div> */}
                <div className="flex">
                    <p className="font-semibold">View : </p> &nbsp;
                    <p className="cursor-pointer" onClick={() => handleSetViewGallery('all')}>
                        <span className={` ${viewGallery === 'all' ? 'text-textBrandBlue' : ''} `}>All</span>&nbsp;
                    </p>{' '}
                    <span>| &nbsp;</span>
                    <div className="relative">
                        <p
                            className={`${unclaimedIcs.length === 0 ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                            onClick={() => unclaimedIcs.length > 0 && handleSetViewGallery('unclaimed')}
                            onMouseEnter={() => unclaimedIcs.length === 0 && setShowTooltip('unclaimed')}
                            onMouseLeave={() => setShowTooltip(null)}
                        >
                            <span
                                className={`${viewGallery === 'unclaimed' ? 'text-textBrandBlue' : ''} ${
                                    unclaimedIcs.length === 0 ? 'text-gray-400' : ''
                                }`}
                            >
                                Unclaimed
                            </span>
                            &nbsp;
                        </p>
                        {showTooltip === 'unclaimed' && unclaimedIcs.length === 0 && (
                            <div className="absolute top-full left-0 mt-1 p-2 bg-grayBgNormal rounded shadow-md z-10 w-64 text-sm text-gray-700">
                                <div className="absolute -top-2 left-4 w-3 h-3 bg-grayBgNormal transform rotate-45"></div>
                                You don't have any unclaimed certificates yet
                            </div>
                        )}
                    </div>
                    <span>| &nbsp;</span>
                    <div className="relative">
                        <p
                            className={`${claimedIcs.length === 0 ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                            onClick={() => claimedIcs.length > 0 && handleSetViewGallery('claimed')}
                            onMouseEnter={() => claimedIcs.length === 0 && setShowTooltip('claimed')}
                            onMouseLeave={() => setShowTooltip(null)}
                        >
                            <span
                                className={`${viewGallery === 'claimed' ? 'text-textBrandBlue' : ''} ${
                                    claimedIcs.length === 0 ? 'text-gray-400' : ''
                                }`}
                            >
                                {' '}
                                Claimed{' '}
                            </span>
                        </p>
                        {showTooltip === 'claimed' && claimedIcs.length === 0 && (
                            <div className="absolute top-full left-0 mt-1 p-2 bg-grayBgNormal rounded shadow-md z-10 w-64 text-sm text-gray-700">
                                <div className="absolute -top-2 left-4 w-3 h-3 bg-grayBgNormal transform rotate-45"></div>
                                You don't have any claimed certificates yet
                            </div>
                        )}
                    </div>
                    <span> &nbsp; | &nbsp;</span>
                    <div className="relative">
                        <p
                            className={`${mintedIcs.length === 0 ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                            onClick={() => mintedIcs.length > 0 && handleSetViewGallery('minted')}
                            onMouseEnter={() => mintedIcs.length === 0 && setShowTooltip('minted')}
                            onMouseLeave={() => setShowTooltip(null)}
                        >
                            <span
                                className={`${viewGallery === 'minted' ? 'text-textBrandBlue' : ''} ${
                                    mintedIcs.length === 0 ? 'text-gray-400' : ''
                                }`}
                            >
                                {' '}
                                Minted
                            </span>
                        </p>
                        {showTooltip === 'minted' && mintedIcs.length === 0 && (
                            <div className="absolute top-full left-0 mt-1 p-2 bg-grayBgNormal rounded shadow-md z-10 w-64 text-sm text-gray-700">
                                <div className="absolute -top-2 left-4 w-3 h-3 bg-grayBgNormal transform rotate-45"></div>
                                You don't have any minted certificates yet
                            </div>
                        )}
                    </div>
                    <span> &nbsp; | &nbsp;</span>
                    <div className="relative">
                        <p
                            className={`${mintRequestedIcs.length === 0 ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                            onClick={() => mintRequestedIcs.length > 0 && handleSetViewGallery('mintrequested')}
                            onMouseEnter={() => mintRequestedIcs.length === 0 && setShowTooltip('mintrequested')}
                            onMouseLeave={() => setShowTooltip(null)}
                        >
                            <span
                                className={`${viewGallery === 'mintrequested' ? 'text-textBrandBlue' : ''} ${
                                    mintRequestedIcs.length === 0 ? 'text-gray-400' : ''
                                }`}
                            >
                                {' '}
                                Mint Requested{' '}
                            </span>
                        </p>
                        {showTooltip === 'mintrequested' && mintRequestedIcs.length === 0 && (
                            <div className="absolute top-full left-0 mt-1 p-2 bg-grayBgNormal rounded shadow-md z-10 w-64 text-sm text-gray-700">
                                <div className="absolute -top-2 left-4 w-3 h-3 bg-grayBgNormal transform rotate-45"></div>
                                You don't have any mint requests yet
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="mb-8">
                <Achievment />
            </div>

            {renderContent()}
            {askToConnectWallet === 'metamask' && (
                <MetamaskConnection
                    close={() => {
                        setAskToConnectWallet('');
                    }}
                    message="Please link your EVM wallet to mint this certificate as an NFT."
                />
            )}

            {askToConnectWallet === 'phantom' && (
                <PhantomConnection
                    close={() => {
                        setAskToConnectWallet('');
                    }}
                    message="Please link your Solana wallet to mint this certificate as an NFT."
                />
            )}

            {/* Minting Progress Modal */}
            {showMintingModal && <MintingProgressModal />}
        </div>
        </div>
    );
}
export default Gallery;
